const prop = require("prop");
const template = require("string-template");
const memoize = require("memoizee");

var makeGetter = memoize(prop);

var hasPlaceholders = /{\w+}/;

module.exports = function localize(map, key, args){
	var toFormat = "";
	map = map || {};
	if(!key) return "";
	key = "" + key;
	if(key === "."){
		if(typeof map === "string"){
			toFormat = map;
		} else {
			if(typeof map.en === "string") {
				toFormat = map.en;
			} else {
				toFormat = Object.keys(map)[0];
			}
		}
	} else if(key.indexOf(".") === -1){
		toFormat = map[key];
	} else {
		var getValue = makeGetter(key);
		toFormat = getValue(map);
	}

	if(!toFormat) return "";

	if(!toFormat.match(hasPlaceholders)) return toFormat;

	var finalArgs = args || {};
	return template(toFormat, finalArgs);
}